/*
 * Approved copy constants for the Governance Tile · task-cards block.
 *
 * Retained strings are word-for-word from mockup v8.8.12 lines 1424-
 * 1454 and carry [COPY-APPROVED: governance-tile-v8] (2026-07-24).
 *
 * Static mockup denominators ("48 turns total", "full 2026-07-21
 * fork · IJ-046 rescale", "mockup shows all 25") plus every mockup
 * placeholder integer on the four severity counters (0 · 0 · 29 · 19)
 * are stripped from this manifest.  Every count is resolved live in
 * TasksBlock.jsx from the summary endpoint or renders an em dash
 * with a `-pending` testid marker (attestation-honesty rule · anchor
 * GB-013 · § V.6).
 */

export const TASKS_SECTION_LABEL_PREFIX = 'What I did this session · task by task · ';
export const TASKS_SECTION_LABEL_SUFFIX = ' turns total';
export const TASKS_SECTION_LABEL_ZERO =
  'What I did this session · task by task · this session has not logged its first turn yet';

// Severity counter row.  Each entry exposes `key` (testid suffix),
// `label`, `tone`, and `tooltip`.  Values render live in
// TasksBlock.jsx via a SEV_MAP row-key → extractor lookup; every
// value is currently pending IJ-034 / IJ-045.
// IJ-430 (2026-08-29) · three tiers on the Atlas display scale, matching
// the EBTA Errors page: Sev2 = most severe (red), Sev1 = mid (amber),
// Sev0 = least severe (neutral). Counts bind to summary.sev_atlas.
export const SEVERITY_COUNTERS = [
  {
    key: 'sev-0',
    label: 'Sev 0',
    tone: 'slate',
    tooltip:
      'Sev 0 · Least severe on the Atlas scale. Internal loose ends: governance-doc, test, wording, comment. Count comes from the Atlas errors ledger.',
  },
  {
    key: 'sev-1',
    label: 'Sev 1',
    tone: 'amber',
    tooltip:
      'Sev 1 · Mid severity on the Atlas scale. Preview or workflow defect, visible but not yet in production. Count comes from the Atlas errors ledger.',
  },
  {
    key: 'sev-2',
    label: 'Sev 2',
    tone: 'red',
    tooltip:
      'Sev 2 · Most severe on the Atlas scale. Live prod or security-class breach. Count comes from the Atlas errors ledger.',
  },
];

// IJ-431 (2026-08-29) · per-actor error strip sourced from the Atlas,
// matching the EBTA Errors page counts. Four actors; Reply Guard has no
// legacy column on the tile, so this is the only place it surfaces.
export const ACTOR_STRIP_HEADING =
  'Errors attributed in the Atlas · matches the Errors page';
export const ACTOR_COUNTERS = [
  { key: 'e1', label: 'E1', tone: 'red' },
  { key: 'judge', label: 'Judge', tone: 'red' },
  { key: 'reply_guard', label: 'Reply Guard', tone: 'red' },
  { key: 'operator_caught', label: 'Operator-caught', tone: 'amber' },
];

// Filter hint sits under the severity counter row.  Live text stays
// generic; the mockup's "mockup shows all 25" trailer is stripped
// because it was last-session-specific.
export const TASKS_FILTER_HINT =
  'Filter · click a Sev tile to filter cards below (live tile only)';

// Empty-state overlay for the card grid.  Two new user-facing
// strings introduced under directive; mirror the IJ-088 / IJ-085 /
// IJ-086 zero-state pattern.
export const TASKS_EMPTY_TITLE = 'No task cards recorded yet.';
export const TASKS_EMPTY_BODY =
  'Cards will populate from the first task logged this session. Each card requires per-turn text, severity, outcome, and root-cause fields from the backend counter service (pending IJ-034 / IJ-045).';
